import React, { useState } from "react";
import {
  Card,
  Typography,
  Collapse,
  Table,
  Row,
  Col,
  Button,
  Tooltip,
  Modal,
} from "../../common/utils/antd-imports/AntdImports";
import moment from "moment";
import "./TermsRequestCard.css";
import { CopyOutlined, DownOutlined, RightOutlined } from "@ant-design/icons";
import RejectTerms from "../../modal/reject-terms/RejectTerms";
import { useMediaQuery } from "react-responsive";
import { useDispatch, useSelector } from "react-redux";
import {
  getSellerTermsRequests,
  updateSellerTermsRequests,
} from "../../../store/thunks/seller-thunks/SellerThunk";
import { formatToUSCurrency, handleCopy } from "../utils/Utils";

const { Text } = Typography;
const { Panel } = Collapse;

const TermsRequestCard = ({ segment }) => {
  const { requestsTerms } = useSelector((state) => state.sellerterms);
  const dispatch = useDispatch();
  const termsList = requestsTerms?.Terms_list || [];
  const [termRequest, setTermRequest] = useState();
  const [rejectModal, setRejectModal] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 700 });
  const [expandedKeys, setExpandedKeys] = useState([]); // array of expanded indexes
  let commentType;
  let otherCommentType;
  let requestStatus;
  let isHoldRequest;
  const formatDate = (inputDate) => {
    if (!inputDate) return "Invalid date";
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sept",
      "Oct",
      "Nov",
      "Dec",
    ];
    const parts = inputDate?.split("-");
    if (parts.length !== 3) return "Invalid date format";
    const [year, month, day] = parts;
    return `${parseInt(day)} ${months[parseInt(month) - 1]} ${year}`;
  };
  const getNextDays = (day) => {
    const date = new Date();
    date.setDate(date.getDate() + day);

    return moment(date).format("MMM DD, YYYY");
  };

  const handleRejectTerms = (terms) => {
    setTermRequest(terms);
    setRejectModal(true);
  };
  const handleAcceptTerms = (terms) => {
    const requestDetails =
      terms?.terms?.find((item) => item?.request_type) || {};

    const isHoldRequest = requestDetails.request_type === "hold_request";
    const payload = {
      approval_status: 1,
      campaign_id: terms?.campaign_id,
      product_id: terms?.product_id,
      comment_type: "",
      other_comments: "",
      ...(isHoldRequest && {
        product_booking_id: terms?.productbookingid,
      }),
    };

    dispatch(updateSellerTermsRequests(payload)).then((res) =>
      dispatch(getSellerTermsRequests(0)),
    );
  };
  const handleAcceptConfirm = (terms) => {
    Modal.confirm({
      title: isHoldRequest ? "Accept Hold Request" : "Accept Terms",
      content: isHoldRequest
        ? "Are you sure you want to accept this hold request?"
        : "Are you sure you want to accept these terms?",

      okText: "Yes, Accept",
      cancelText: "Cancel",
      centered: true,
      className: "accept-confirm-modal",
      okButtonProps: {
        className: "terms-accept-btn",
      },

      cancelButtonProps: {
        className: "reject-btn",
      },
      onOk: () => {
        handleAcceptTerms(terms);
      },
    });
  };
  const toggleExpanded = (index) => {
    setExpandedKeys((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index],
    );
  };
  const formatString = (str) => {
    return str
      ?.split("_")
      ?.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      ?.join(" ");
  };
  const renderComponentByKey = (segment, terms) => {
    switch (segment) {
      case "pending_terms":
        return (
          <div
            className="terms-actions"
            style={{
              opacity: requestStatus === 3 ? 0.5 : 1,
              pointerEvents: requestStatus === 3 ? "none" : "auto",
            }}
          >
            <Button
              className="reject-btn"
              onClick={() => handleRejectTerms(terms)}
            >
              {isHoldRequest ? "Reject Request" : "Reject Terms"}
            </Button>
            <Button
              className="terms-accept-btn"
              onClick={() => handleAcceptConfirm(terms)}
            >
              {isHoldRequest ? "Accept  Request" : "Accept Terms"}
            </Button>
          </div>
        );
      case "declined_terms":
        return (
          <div className="status rejected">
            <Row>
              <Col span={12}>
                <Text className="terms-info-row">Your Comments</Text>
              </Col>
            </Row>
            <Row>
              <Col>
                <Text className="terms-info-row-txt">
                  {formatString(commentType) === "Other"
                    ? otherCommentType
                    : formatString(commentType)}
                </Text>
              </Col>
            </Row>
          </div>
        );
      default:
        return null;
    }
  };

  const columns = [
    {
      title: "Terms Type",
      dataIndex: "termType",
      key: "termType",
    },
    {
      title: "Your Terms",
      dataIndex: "yourTerms",
      key: "yourTerms",
    },
    {
      title: "Buyer Request",
      dataIndex: "buyerRequest",
      key: "buyerRequest",
    },
  ];

  let createdAt;
  const getHoldDurationDays = (startDate, endDate) => {
    if (!startDate || !endDate) return 0;

    return moment(endDate).diff(moment(startDate), "days") + 1;
  };
  return (
    <>
      {termsList?.data?.map((terms, i) => {
        const tableData = terms?.terms?.map((item, index) => ({
          key: index,
          termType:
            item.term_type === "stripe_percent"
              ? "Upfront" + `(${getNextDays(0)})`
              : item.term_type === "net_15_percent"
                ? "Net 15" + `(${getNextDays(15)})`
                : item.term_type === "net_30_percent"
                  ? "Net 30" + `(${getNextDays(30)})`
                  : item.term_type === "net_45_percent"
                    ? "Net 45" + `(${getNextDays(45)})`
                    : item.term_type === "net_60_percent"
                      ? "Net 60" + `(${getNextDays(60)})`
                      : item.term_type === "net_90_percent"
                        ? "Net 90" + `(${getNextDays(60)})`
                        : item.term_type || "-",
          yourTerms: `${formatToUSCurrency(item?.cal_amount?.toFixed(2))} (${
            item?.seller_percentage
          }%)`,
          buyerRequest: `${formatToUSCurrency(
            item?.payment_percentage?.toFixed(2),
          )} (${(item?.custom_payment_percentage || 0)?.toFixed(0)}%)`,
        }));

        createdAt = terms?.terms?.[0]?.created_at;
        requestStatus = terms?.terms?.[0]?.approval_status;
        commentType = terms?.terms?.[0]?.comment_type;
        otherCommentType = terms?.terms?.[0]?.other_comments;
        const requestDetails =
          terms?.terms?.find((item) => item?.request_type) || {};
        isHoldRequest = requestDetails?.request_type === "hold_request";

        return (
          <>
            <Col span={24}>
              <>
                <Card
                  className="terms-card"
                  bodyStyle={{ padding: 24 }}
                  title={
                    <Row
                      justify="start"
                      style={{ padding: " 24px 0px 0px 5px" }}
                    >
                      <Text
                        strong
                        className="terms-title mobile-card-title-size"
                      >
                        {isHoldRequest ? "Hold Request" : "Terms Request"}
                      </Text>
                      {requestStatus === 3 && (
                        <div className="request-status-sec">
                          <Text className="with-drawn-txt">Withdrawn!</Text>
                        </div>
                      )}
                    </Row>
                  }
                  extra={
                    <Text className="header-date">
                      {moment(createdAt).format("MMM DD, YYYY")}
                    </Text>
                  }
                >
                  {isMobile ? (
                    <>
                      <Row>
                        <Col>
                          <Text className="terms-info-row">Campaign ID</Text>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Tooltip title={terms?.cid}>
                            <Text className="terms-info-row-txt truncate">
                              {terms?.cid}
                            </Text>
                          </Tooltip>
                        </Col>
                      </Row>
                      <Row className="row-gap">
                        <Col>
                          <Text className="terms-info-row">
                            {isHoldRequest
                              ? "Hold Duration"
                              : "Campaign Duration"}
                          </Text>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Text className="terms-info-row-txt">
                            {isHoldRequest ? (
                              <>
                                {formatDate(requestDetails?.hold_request_start)}{" "}
                                - {formatDate(requestDetails?.due_date)}
                              </>
                            ) : (
                              <>
                                {formatDate(terms?.campaign_start_date)} -{" "}
                                {formatDate(terms?.campaign_end_date)}
                              </>
                            )}
                          </Text>
                        </Col>
                      </Row>
                      <Row className="row-gap">
                        <Col>
                          <Text className="terms-info-row">Product Name</Text>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Text className="terms-info-row-txt truncate">
                            <Tooltip title={terms?.title}>
                              {terms?.title}
                            </Tooltip>
                          </Text>
                        </Col>
                      </Row>
                      <Row className="row-gap">
                        <Col>
                          <Text className="terms-info-row">
                            Product Duration
                          </Text>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Text className="terms-info-row-txt">
                            {formatDate(terms?.booked_from)} -{" "}
                            {formatDate(terms?.booked_to)}
                          </Text>
                        </Col>
                      </Row>
                      <Row className="row-gap">
                        {isHoldRequest && (
                          <Col>
                            <Text className="terms-info-row">
                              Total Hold Duration
                            </Text>
                          </Col>
                        )}
                      </Row>
                      <Row className="row-gap">
                        {isHoldRequest && (
                          <Col>
                            <Text className="terms-info-row-txt">
                              {getHoldDurationDays(
                                requestDetails?.hold_request_start,
                                requestDetails?.due_date,
                              )}{" "}
                              Days
                            </Text>
                          </Col>
                        )}
                      </Row>
                      <Row className="row-gap">
                        <Col>
                          <Text className="terms-info-row">Product Price</Text>
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          <Text className="terms-info-row-txt">
                            {formatToUSCurrency(
                              Number(terms?.offerpriceperselectedDates).toFixed(
                                2,
                              ),
                            )}
                          </Text>
                        </Col>
                      </Row>
                      {!isHoldRequest &&
                        tableData?.map((row, index) => (
                          <>
                            <Row className="row-gap">
                              <Col>
                                <Text className="terms-installment">
                                  {row?.termType}
                                </Text>
                              </Col>
                            </Row>
                            <Row>
                              <Col>
                                <Text className="terms-info-row-txt">
                                  Your Terms: {row?.yourTerms}
                                </Text>
                              </Col>
                            </Row>
                            <Row>
                              <Col>
                                <Text className="terms-info-row-txt">
                                  Buyer Request: {row?.buyerRequest}
                                </Text>
                              </Col>
                            </Row>
                          </>
                        ))}
                    </>
                  ) : (
                    <>
                      <Row>
                        <Col span={9}>
                          <Text className="terms-info-row">Campaign ID</Text>
                        </Col>
                        <Col span={9}>
                          <Text className="terms-info-row">
                            {isHoldRequest
                              ? "Hold Duration"
                              : "Campaign Duration"}
                          </Text>
                        </Col>
                        {isHoldRequest && (
                          <Col span={6}>
                            <Text className="terms-info-row">
                              Total Hold Duration
                            </Text>
                          </Col>
                        )}
                      </Row>

                      <Row>
                        <Col span={9}>
                          <div className="product-copy-text-field">
                            <Tooltip title={terms.cid}>
                              <Text className="terms-info-row-txt truncate">
                                {terms?.cid}
                              </Text>
                            </Tooltip>
                            <CopyOutlined
                              onClick={(e) => {
                                e.stopPropagation(); // prevent tooltip close
                                handleCopy(terms?.cid);
                              }}
                              className="copy-icon"
                            />
                          </div>
                        </Col>
                        <Col span={9}>
                          <Text className="terms-info-row-txt truncate">
                            {isHoldRequest ? (
                              <>
                                <Tooltip
                                  title={
                                    <>
                                      {formatDate(
                                        requestDetails?.hold_request_start,
                                      )}{" "}
                                      - {formatDate(requestDetails?.due_date)}
                                    </>
                                  }
                                >
                                  {formatDate(
                                    requestDetails?.hold_request_start,
                                  )}{" "}
                                  - {formatDate(requestDetails?.due_date)}
                                </Tooltip>
                              </>
                            ) : (
                              <>
                                {formatDate(terms?.campaign_start_date)} -{" "}
                                {formatDate(terms?.campaign_end_date)}
                              </>
                            )}
                          </Text>
                        </Col>
                        {isHoldRequest && (
                          <Col span={6}>
                            <Text className="terms-info-row-txt ">
                              {getHoldDurationDays(
                                requestDetails?.hold_request_start,
                                requestDetails?.due_date,
                              )}{" "}
                              Days
                            </Text>
                          </Col>
                        )}
                      </Row>
                      <Row style={{ paddingTop: 15 }}>
                        <Col span={9}>
                          <Text className="terms-info-row">Product Name</Text>
                        </Col>
                        <Col span={9}>
                          <Text className="terms-info-row">
                            Product Duration
                          </Text>
                        </Col>
                        <Col span={6}>
                          <Text className="terms-info-row">Product Price</Text>
                        </Col>
                      </Row>
                      <Row>
                        <Col span={9}>
                          <div className="product-copy-text-field">
                            <Tooltip title={terms?.title}>
                              <Text className="terms-info-row-txt truncate">
                                {terms?.title}
                              </Text>
                            </Tooltip>

                            <CopyOutlined
                              onClick={(e) => {
                                e.stopPropagation(); // prevent tooltip close
                                handleCopy(terms?.title);
                              }}
                              className="copy-icon"
                            />
                          </div>
                        </Col>
                        <Col span={9}>
                          <Text className="terms-info-row-txt">
                            <Text className="terms-info-row-txt">
                              {formatDate(terms?.booked_from)} -{" "}
                              {formatDate(terms?.booked_to)}
                            </Text>
                          </Text>
                        </Col>
                        <Col span={6}>
                          <Text className="terms-info-row-txt">
                            {formatToUSCurrency(
                              Number(terms?.offerpriceperselectedDates).toFixed(
                                2,
                              ),
                            )}{" "}
                          </Text>
                        </Col>
                      </Row>
                      <div className="requests-table">
                        <Collapse
                          activeKey={expandedKeys.includes(i) ? ["1"] : []}
                          onChange={() => toggleExpanded(i)}
                          expandIconPosition="start"
                          expandIcon={({ isActive }) =>
                            isActive ? (
                              <DownOutlined className="icon-arrow" />
                            ) : (
                              <RightOutlined />
                            )
                          }
                          bordered={false}
                          ghost
                        >
                          <Panel
                            header={
                              <Text className="panel-title">
                                {isHoldRequest ? "Comment" : "Terms Comparison"}
                              </Text>
                            }
                            key="1"
                          >
                            {isHoldRequest ? (
                              <>
                                <Row
                                  style={{
                                    width: "100%",
                                    display: "flex",
                                    flex: "wrap",
                                  }}
                                >
                                  <Text className="terms-info-row-txt">
                                    {requestDetails?.hold_comments || "-"}
                                  </Text>
                                </Row>
                              </>
                            ) : (
                              <Table
                                columns={columns}
                                dataSource={tableData}
                                pagination={false}
                                bordered
                                size="small"
                              />
                            )}
                          </Panel>
                        </Collapse>
                      </div>
                    </>
                  )}
                  {renderComponentByKey(segment, terms)}
                </Card>
              </>
            </Col>
          </>
        );
      })}
      <RejectTerms
        rejectModal={rejectModal}
        setRejectModal={setRejectModal}
        termRequest={termRequest}
      />
    </>
  );
};

export default TermsRequestCard;
